
(function loadingInterceptorDefinition() {

    'use strict';

    angular.module('Loading')
        // Este interceptor hará que se muestre el loading cuando se utiliza
        // $http para hacer alguna consulta.
        .factory('loadingInterceptor', [
            'loading', '$q',
            function(loading, $q) {

                return {
                    request: function(config) {
                        loading.show();
                        return config;
                    },
                    requestError: function(rejection) {
                        loading.hide();
                        return $q.reject(rejection);
                    },
                    responseError: function(rejection) {
                        loading.hide();
                        return $q.reject(rejection);
                    },
                    response: function(response) {
                        loading.hide();
                        return response;
                    }
                };
            }
        ])
        .config([
            '$httpProvider', function(httpProvider) {
                httpProvider.interceptors.push('loadingInterceptor');
            }
        ]);

})();